import { render, staticRenderFns } from "./AddToPurchaseListDialog.vue?vue&type=template&id=da7c4b6a"
import script from "./AddToPurchaseListDialog.vue?vue&type=script&lang=ts"
export * from "./AddToPurchaseListDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports